import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useEffect } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsProxy({
  productType
}) {
  const parsedPathParams = useParsedSearchResultsPathParams();
  const history = useHistory();
  const {
    AGENT_TEAM,
    CATEGORY
  } = useFilterConfig();
  useEffect(() => {
    if (!(productType || Object.keys(parsedPathParams).length)) {
      return;
    }
    const urlParams = new URLSearchParams(history.location.search);

    // SOLUTIONS_PARTNER_PROFILE is excluded because the product type is
    // inferred from the /explore/solutions-partners path.
    if (productType && productType !== 'SOLUTIONS_PARTNER_PROFILE') {
      urlParams.set(`${KEY_PREFIX}PRODUCT_TYPE`, productType);
    }
    if (parsedPathParams.page) {
      urlParams.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    }
    if (productType === 'APP' && parsedPathParams.categorySlug) {
      var _CATEGORY$options$fin;
      if (!(CATEGORY && CATEGORY.options.length)) return;
      const categoryEnumValue = (_CATEGORY$options$fin = CATEGORY.options.find(o => o.slug === parsedPathParams.categorySlug)) === null || _CATEGORY$options$fin === void 0 ? void 0 : _CATEGORY$options$fin.value;
      if (categoryEnumValue) {
        urlParams.set(`${KEY_PREFIX}${CATEGORY.field}`, categoryEnumValue);
      }

      // The legacy app marketplace used /apps/:slug for both categories and
      // individual app listings. If the slug doesn't match a category, assume
      // it's a listing slug and redirect to the listing details page.
      if (!categoryEnumValue) {
        history.replace(generatePath(Paths.LISTING_DETAILS, {
          listingSlug: parsedPathParams.categorySlug
        }));
        return;
      }
    }
    if (productType === 'AGENT' && parsedPathParams.teamSlug) {
      var _AGENT_TEAM$options$f;
      if (!(AGENT_TEAM && AGENT_TEAM.options.length)) return;
      const teamEnumValue = (_AGENT_TEAM$options$f = AGENT_TEAM.options.find(o => o.slug === parsedPathParams.teamSlug)) === null || _AGENT_TEAM$options$f === void 0 ? void 0 : _AGENT_TEAM$options$f.value;
      if (teamEnumValue) {
        urlParams.set(`${KEY_PREFIX}${AGENT_TEAM.field}`, teamEnumValue);
      }
    }
    const pathname = productType === 'SOLUTIONS_PARTNER_PROFILE' ? Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS : Paths.SEARCH_RESULTS;
    const search = urlParams.toString();
    history.replace({
      pathname,
      search: search ? `?${search}` : ''
    });
  }, [AGENT_TEAM, CATEGORY, history, parsedPathParams, productType]);
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "1600"
  });
}